<template>
    <div class="student-name">{{ participant.user_name }}</div>
    <div v-for="observation in globalState.observations" v-bind:key="observation.shortname" class="grid-cell">
        <ObservationCheck :observation="observation" :participant="participant" @change="observationChanged">
        </ObservationCheck>
    </div>
</template>

<script setup>
import { ref } from "vue";
import ObservationCheck from "@/components/classroom/sidePanel/observations/ObservationCheck.vue";
import { globalState } from '@/scripts/store';

const emit = defineEmits(['observationChanged']);

const props = defineProps({
    participant: Object
});

function observationChanged(data) {
    emit('observationChanged', data);
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.observation-row {
    display: flex;
    list-style-type: none;
    padding: 0;
    margin: 0.25vh 0;

    li {
        input {
            margin: 0 5px;
        }
    }

    &-tick {
        width: 30px;
        text-align: center;
    }

    &-name {
        flex-grow: 1;
        overflow: hidden;

        &-inner {
            display: flex;
            min-width: 0;
        }

        div {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}

/* 3. Style student names and checkbox cells */
.student-name {
    font-weight: bold;
    text-align: right;
    padding-right: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.grid-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}
</style>